import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FlipOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/flip-operator/geometry-flip-operator-node"
import {GeometryFlipOperatorNode, flipOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/flip-operator/geometry-flip-operator-node"

export type MeshGeometryFlipOperatorParameters = FlipOperatorParameters<MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryFlipOperatorParameters> = {
    nodeClass: "MeshGeometryFlipOperator",
    validation: {
        parameters: flipOperatorParametersSchema(meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryFlipOperator extends GeometryFlipOperatorNode<2, MeshGeometryAttributeSetLikeNode> implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
